import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Cookies from 'js-cookie';

declare global {
  interface Window {
    fbq: (...args: any[]) => void;
  }
}

const Install = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const adSource = searchParams.get('adSource');
    const [ip, setIp] = useState<string | null>(null);
    const [fbc, setFbc] = useState<string | null>(null);
    const [fbp, setFbp] = useState<string | null>(null);
    const [userAgent, setUserAgent] = useState<string | null>(null);

    useEffect(() => {

        // Get the _fbc and _fbp cookies
        const fbc = Cookies.get('_fbc') || null; // Facebook Click ID (fbc)
        const fbp = Cookies.get('_fbp') || null; // Facebook Pixel ID (fbp)
        const ua = navigator.userAgent || null;

        setFbc(fbc);
        setFbp(fbp);
        setUserAgent(ua);

        // Log the values to the console
        console.log("Facebook Click ID (fbc):", fbc);
        console.log("Facebook Pixel ID (fbp):", fbp);
        console.log("User Agent:", ua);

        fetch('https://api.ipify.org?format=json')
        .then(response => response.json())
        .then(data => {
            const userIp = data.ip;
            setIp(userIp);
            console.log("User IP:", userIp);

            if (isValidData(userIp, fbc, fbp)) {
                // If valid, send the API request
                sendApiRequest(userIp, fbc, fbp, ua);
            } else {
                console.log("One or more required values are missing or invalid.");
                redirect(ua || "");
            }
        })
        .catch(error => {
            console.log("Error fetching IP address:", error);
            redirect(ua || "");
        });
    }, [navigate]);

    // Function to validate if the data is not null, empty, or undefined
    const isValidData = (ip: string | null, fbc: string | null, fbp: string | null) => {
        return ip && fbc && fbp && ip.trim() !== "" && fbc.trim() !== "" && fbp.trim() !== "";
    };

    const redirect = (userAgent: string) => {
        console.log("Redirecting to App Store");
        console.log("User Agent:", userAgent);
        if (/android/i.test(userAgent)) {
            window.location.href = "https://play.google.com/store/apps/details?id=com.optionbase.optionbase&hl=ln";
        } else if (/iPad|iPhone|iPod/.test(userAgent) || /Macintosh/.test(userAgent)) {
            window.location.href = "https://apps.apple.com/in/app/returns-stocks-investments/id6736361692";
        } else {
            window.location.href = "https://play.google.com/store/apps/details?id=com.optionbase.optionbase&hl=ln"; // Default to App Store
        }
    }

    // Function to send the API request
    const sendApiRequest = (ip: string, fbc: string | null, fbp: string | null, ua:string | null) => {
        const apiUrl = "https://tradeinsights.co.in/v1/api/metas/create";
        const payload: any = {
            ip: ip,
            fbc: fbc,
            fbp: fbp,
            user_agent: ua,
        };
        if (adSource) {
            payload.ad_source = adSource;
            if (window.fbq && adSource == "tamil") {
                console.log("Attempting to send TamilAd event to Facebook Pixel");
                window.fbq('track', 'TamilAd');
                console.log("TamilAd event sent");
            } else {
                console.log("Facebook Pixel not initialized or adSource is not 'tamil'");
            }
          }

        fetch(apiUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
        })
        .then(response => response.json())
        .then(data => {
            console.log("API response:", data);
            // Redirect after API request is completed
            redirect(ua || "");
        })
        .catch(error => {
            console.log("Error sending API request:", error);
            redirect(ua || "");
        });
    };

    return <h2>Redirecting...</h2>;
};

export default Install;
